import React, { Component } from 'react';
import Form from 'react-jsonschema-form';
import {IconButton, Button } from '@material-ui/core';
import { Close, Create, WbSunny } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import DisplayUserInfo from './DisplayUserInfo';
var $ = require('jquery');

class ProfileBoxItemBoxStatus extends Component{
    state = {          
          error: '',
          styleError: {
              color: 'white'
          },
          info: '',
          values: {},
          form: {
              jsonSchema:{
                  properties:{}
              },
              uiSchema:{}
          },
          showUpdateForm:"",
          update:false,
        }
    
    closeBoxInfo(e) {
        e.preventDefault();
        this.setState({ update: false });
    }
    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
    componentDidMount() {
        this.getSolarInfo()
      
    }
    getSolarInfo() {        
        var methodName = 'Profile-user-solarinfo';
        var urlBoxFreeOfAssociation = "/userinfo/info/all?boxAssoId=" + this.props.boxAssoId+"&info=solarinfo";
        // if (this.props.userId === ''){
        //     console.log('[DEBUG], ', methodName, ' userID empty ,',this.props.boxId);
        //     urlBoxFreeOfAssociation = "userinfo/info/all?userID=" + this.props.boxId+"&info=solarinfo";
        // }
        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            let info = '';
            try {
                var data = result; //var data = JSON.parse(result);
                if (this.isJson(data.info) ){
                    info =JSON.parse(data.info);
                }else{
                    info = data.info;
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            if (info !== "nullerr"){
                this.setState({
                    info: info,
                    values:info,
                });
            }
        }.bind(this));
    }
    getSchema= async ({formData}) => {
        console.log('[INFO] get Schema profile user');
            this.setState({
                update:!this.state.update,
                MenuUserInfoStatus: 'dropdown'
            })
            
            try {
                if (this.state.update === false) {
                    // var idInfo = this.props.userId;
                    // if (idInfo === ''){
                    //     idInfo = this.props.boxId;
                    // }
                    const infos = await fetch('/schema/getCustomSchema',{
                        method:'POST',
                        headers: { 
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                        },
                        body:JSON.stringify({
                            "idSchema":"solar",
                            "boxAssoId": this.props.boxAssoId,
                        }),
                        
                        credentials: 'same-origin',
                    });
                    let body = await infos.json();                
    
                    // body = body === null ? [] : body
                    this.setState({
                        form:{
                            uiSchema:JSON.parse(body.uiSchema),
                            jsonSchema:JSON.parse(body.jsonSchema),
    
                        },
                        schemaID:body.schemaID,
                        
                    })
                        
                    console.log("[INFO] get Schema profile user", this.state);  
                }

            } catch (error) {
                console.log("[ERROR] get Schema profile user",error)
                return
            }
    }
    updateInfo = (field) => {
        console.log('[INFO] get forms profile user');
        
        const values = this.state.values;
        const schema = this.state.form.jsonSchema.properties;
        const ui = this.state.form.uiSchema

        if(values){

            let display = values[field];//copy value prevent changing real value
            let specificSchema = {};//will contain current json schema
            let specificUi = {};//will contain current ui schema
            let formDatas = {};//will contain current Db value to prefill the form

            if(Array.isArray(display)){//if value is array, join values
                display = display.join(", ");
            }

            Object.keys(schema).map((schKey, j) => {//get jsonshcema for each field

                if(schKey == field){
                    specificSchema = {
                        "type":"object",
                        "properties":{
                            [schKey]: schema[schKey]
                        }
                    };//..., properties:{Age:{title: "Age", type: "integer", minimum: 16, maximum: 100}}

                    formDatas = {
                        [field]:values[field]
                    };//{"Age":24} = old/DB value
                }
                return;
            });

            Object.keys(ui).map((uiKey) => {//get uishcema for each field
                if(uiKey == field){
                    specificUi = {
                        [uiKey]:ui[uiKey]
                    };
                    //{Age: { ui: widget:"range"}}
                }
                return;
            });

            return[
                specificSchema,
                specificUi,
                formDatas         
            ]

        }
    }
    handleSubmit= async ({formData}) => {
        //HERE formData is an attribute from the result object of the form
        console.log("[INFO] SUBMIT",formData);
        try {
            // var idInfo = this.props.userId;
            // if (idInfo === ''){
            //     idInfo = this.props.boxId;
            // }
            const infos = await fetch('/schema/updateUser',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    "data":formData,
                    "boxAssoId": this.props.boxAssoId,
                    "idSchema":"solar"
                }),
                
                credentials: 'same-origin',
            });
            let body = await infos.json();                
            console.log("[INFO] submit update profile user", body);  
            if(body.errorCode === 200){
                this.setState({
                    showUpdateForm: ""
                })
                this.getSolarInfo()
            }

        } catch (error) {
            console.log("[ERROR] submit update profile user",error)
            return
        }
        
    }
    render() {
        const { info, update } = this.state;
        console.log('[DEBUG], Info USER , info : ', info);

        return (
            <MiniCard 
                title="Solar System Info"
                action={
                    <IconButton onClick={this.getSchema} color="primary" >
                        {update ? <Close /> : <Create />}
                    </IconButton>
                }
                avatar={<WbSunny />}
            >

                {info &&
                    <DisplayUserInfo
                        {...this.state}
                        updateInfo={this.updateInfo}
                        handleSubmit={this.handleSubmit}
                        updateTarget={(target) => this.setState({
                            showUpdateForm: target
                        })}

                    />
                }
            </MiniCard>

        )
    }
};
export default ProfileBoxItemBoxStatus
